const VERTICAL_CONFIG = {
  IS_BOA_ENABLED: window.Cypress ? window.Cypress.env('CYPRESS_HAS_BOA') : true,
  IS_PASSPORT360_ENABLED: window.Cypress
    ? window.Cypress.env('CYPRESS_HAS_PASSPORT360')
    : true,
};

export default VERTICAL_CONFIG;
